import {
  IconRoute,
  IconTransferIn,
  IconTransferOut,
} from '@tabler/icons-react';
import { PlanMarket } from '@zorro/clients';
import { IconNotApplicable } from '@zorro/shared/assets';

export const PlanMarketConfig = {
  [PlanMarket.OFF_EXCHANGE]: {
    icon: IconTransferOut,
    color: 'blue',
    badgeBg: 'var(--color-background-tag-blue)',
    badgeColor: 'var(--color-text-tag-blue)',
  },
  [PlanMarket.ON_EXCHANGE]: {
    icon: IconTransferIn,
    color: 'green',
    badgeBg: 'var(--color-background-tag-green)',
    badgeColor: 'var(--color-text-tag-green)',
  },
  [PlanMarket.BOTH_MARKETS]: {
    icon: IconRoute,
    color: 'indigo',
    badgeBg: 'var(--color-background-tag-indigo)',
    badgeColor: 'var(--color-text-tag-indigo)',
  },
  NOT_APPLICABLE: {
    icon: IconNotApplicable,
    color: 'red',
    badgeBg: 'var(--color-background-tag-red)',
    badgeColor: 'var(--color-text-tag-red)',
  },
} as const;

export function PlanMarketIcon({ planMarket }: { planMarket: PlanMarket }) {
  const { icon: IconComponent } = PlanMarketConfig[planMarket];
  return <IconComponent />;
}
